/** 금액은 문자열/BigInt로만 다룬다. 부동소수점으로 바꾸지 않는다. */
export const AMOUNT_PATTERN = /^[1-9][0-9]{0,11}$/;

export function krw(value: string | bigint | null | undefined, sign: '' | '+' | '-' = ''): string {
  if (value === null || value === undefined) return '-';
  const n = typeof value === 'bigint' ? value : BigInt(value);
  const negative = n < 0n;
  const body = (negative ? -n : n).toLocaleString('ko-KR');
  return `${negative ? '−' : sign === '-' ? '−' : sign}${body}원`;
}

/** 입력란의 "3,000" "3000원" 같은 값을 금액 문자열로. 정수가 아니면 null. */
export function parseAmountInput(input: string): string | null {
  const cleaned = input.replace(/[,\s원]/g, '');
  return AMOUNT_PATTERN.test(cleaned) && BigInt(cleaned) <= 999_999_999_999n ? cleaned : null;
}

/** 비율(%) — BigInt로 계산해 소수 첫째 자리까지. */
export function percent(part: string | bigint, total: string | bigint): number {
  const t = BigInt(total);
  if (t <= 0n) return 0;
  return Number((BigInt(part) * 1000n) / t) / 10;
}

export const kindLabel: Record<string, string> = { income: '수입', expense: '지출', transfer: '이체', refund: '환불' };

export function formatDateTime(value: string | null): string {
  if (!value) return '-';
  return new Intl.DateTimeFormat('ko-KR', { timeZone: 'Asia/Seoul', dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
}
